<h2 mat-dialog-title>Ajouter des critères</h2>

<div class="info-banner">
  <mat-icon>info_outline</mat-icon>
  <span>
    Les nouveaux critères seront automatiquement marqués <strong>N/A</strong> sur la note cible, la note au démarrage de mission, la note fin de montée en compétences
     et les mois déjà créés — vous n'aurez à les évaluer qu'à partir de maintenant.
  </span>
</div>

<div *ngIf="backendError" class="backend-error-banner">
  <mat-icon>error_outline</mat-icon>
  <span>{{ backendError }}</span>
</div>

<mat-dialog-content class="dialog-content">

  <!-- Sections UO -->
  <div *ngFor="let section of uoSections; let i = index" class="uo-section">

    <div class="uo-section-header">
      <span class="uo-section-title">
        <mat-icon>add_business</mat-icon>
        {{ section.uoLibelle || 'Unité organisationnelle ' + (i + 1) }}
      </span>
      <button mat-icon-button color="warn"
              *ngIf="uoSections.length > 1"
              (click)="removeUoSection(i)"
              matTooltip="Supprimer cette section">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="row-fields">
      <mat-form-field appearance="outline" color="accent" class="half-width">
        <mat-label>Unité organisationnelle</mat-label>
        <mat-select [(ngModel)]="section.selectedUoId" (selectionChange)="onUoChange(section)">
          <mat-option *ngFor="let uo of unitesOrganisationnelles" [value]="uo.id">
            {{ uo.code }} — {{ uo.libelle }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" color="accent" class="half-width">
        <mat-label>Catégorie</mat-label>
        <mat-select [(ngModel)]="section.selectedCategorieId"
                    (selectionChange)="onCategorieChange(section)"
                    [disabled]="!section.selectedUoId">
          <mat-option *ngFor="let cat of section.categoriesFiltrees" [value]="cat.id">
            {{ cat.nom }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div *ngIf="section.competencesFiltrees.length > 0" class="competence-chips">
      <div *ngFor="let comp of section.competencesFiltrees"
           class="competence-chip"
           [class.already-added]="isAlreadyAdded(comp.id)"
           [class.already-existing]="isAlreadyInEvaluation(comp.id)"
           (click)="addCompetence(comp)">
        <mat-icon *ngIf="isAlreadyInEvaluation(comp.id)">block</mat-icon>
        <mat-icon *ngIf="!isAlreadyInEvaluation(comp.id) && isAlreadyAdded(comp.id)">check</mat-icon>
        <mat-icon *ngIf="!isAlreadyInEvaluation(comp.id) && !isAlreadyAdded(comp.id)">add</mat-icon>
        <span>{{ comp.libelle }}</span>
      </div>
    </div>

    <div *ngIf="section.selectedCategorieId && section.competencesFiltrees.length === 0"
         class="empty-hint">
      Aucune compétence disponible pour cette catégorie.
    </div>

  </div>

  <button mat-stroked-button color="primary" class="btn-add-uo" (click)="addUoSection()">
    <mat-icon>add</mat-icon> Ajouter une autre UO
  </button>

  <!-- Liste des compétences sélectionnées -->
  <div class="section-header" style="margin-top: 20px;">
    <span class="section-title">À ajouter ({{ competencesSelectionnees.length }})</span>
  </div>

  <div *ngIf="competencesSelectionnees.length === 0" class="empty-hint">
    Choisissez une UO et une catégorie pour sélectionner des critères à ajouter.
  </div>

  <div class="preview-table" *ngIf="competencesSelectionnees.length > 0">
    <table>
      <thead>
        <tr>
          <th>Catégorie</th>
          <th>Compétence</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let comp of competencesSelectionnees">
          <td class="td-categorie">{{ comp.categorieNom }}</td>
          <td>{{ comp.libelle }}</td>
          <td class="td-action">
            <button mat-icon-button color="warn" (click)="removeCompetence(comp.id)" matTooltip="Retirer">
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Annuler</button>
  <button mat-raised-button color="primary"
          type="button"
          (click)="onSubmit()"
          [disabled]="competencesSelectionnees.length === 0 || isSubmitting">
    <mat-icon>add</mat-icon> Ajouter {{ competencesSelectionnees.length }} critère(s)
  </button>
</mat-dialog-actions>